import { render } from "./CategoryScoresChart.vue?vue&type=template&id=0b66170e&scoped=true"
import script from "./CategoryScoresChart.vue?vue&type=script&lang=js"
export * from "./CategoryScoresChart.vue?vue&type=script&lang=js"

import "./CategoryScoresChart.vue?vue&type=style&index=0&id=0b66170e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b66170e"]])

export default __exports__